<template>
  <div class="course-section">
    <div class="header w1200 clearfix">
      <div class="header-left">
        <div class="hr"></div>
        <h2>专业课程</h2>
        <h3>SINCE 1961</h3>
      </div>
      <div class="header-right">Curriculum</div>
    </div>
    <div class="allContent_wrap">
      <div class="allContent">
        <p>Kids 'R' Kids美国总部的课程研发团队由来自早期教育、儿童心理发展、语言学等各领域的专家学者组成。他们在研究了大量基于0-6岁儿童发展理论和实践案例之后，最终在皮亚杰（Jean Piaget）的儿童认知理论、维果斯基（Lev Vygotsky）的最近发展区概念以及斯米兰斯基（Sara Smilansky）的玩中学理念的基础之上，开发出一套适合现代社会儿童发展的Kids 'R' Kids独创课程体系。</p>
        <div class="allContent_right">
          <p class="span">Kids 'R' Kids 课程理论基础</p>
          <div class="img1">
            <img
              class="image1"
              src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_person1.jpg"
            >
            <p>Jean Piaget</p>
            <span></span>
            <h5>儿童认知理论</h5>
          </div>
          <div class="img2">
            <img
              class="image2"
              src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_person2.jpg"
            >
            <p>Lev Vygotsky</p>
            <span></span>
            <h5>最近发展区概念</h5>
          </div>
          <div class="img3">
            <img
              class="image3"
              src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_person3.jpg"
            >
            <p>Sara Smilansky</p>
            <span></span>
            <h5>玩中学理念</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="blue_wrap">
      <div class="blue">
        <p>Features of Kids 'R' Kids Curriculum</p>
        <p class="feature">
          <span>课程特色</span>
        </p>
        <div class="square">
          <div class="square-bg" v-show="this.$store.state.isMobile"></div>
          <div class="square1">
            <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_icon1.png">
            <p>半个世纪探究实践</p>
            <span>确保教学高水准</span>
            <i>Over 50 years practice</i>
          </div>
          <div class="square2">
            <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_icon2.png">
            <p>0-6岁全套幼儿园课程</p>
            <span>从婴幼儿阶段构建学霸大脑</span>
            <i>Academic learning</i>
          </div>
          <div class="square3">
            <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_icon3.png">
            <p>与美国同步课程</p>
            <span>完美对接国际教育</span>
            <i>Keep pace with global trend</i>
          </div>
          <div class="square4">
            <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_icon4.png">
            <p>独创特色中文课程</p>
            <span>练就强大中英文双语能力</span>
            <i>Chinese Curriculum</i>
          </div>
        </div>
      </div>
    </div>
    <div class="practice_wrap">
      <div class="practice">
        <h1>Over 50 years practice</h1>
        <h3>
          半个世纪探究实践——
          <span id="span">确保教学高水准</span>
        </h3>
        <p>Kids 'R' Kids课程非常注重理论依据的完善性和执行的精细度。0-6岁，是儿童大脑发育的高峰期。婴幼儿在0-3岁期间甚至每个月龄就会发生很大变化。Kids 'R' Kids的课程以每半岁为一套完整的教案，课程设计以半岁作为年龄分界，每个阶段都有符合该年龄段儿童发展的标准化教学目标。</p>
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img1.jpg">
        <p
          id="second"
        >在翔实标准的课程指导下，教师可以按照高标准的教学要求进行授课。标准课程设计已细致到一日流程的各个教学环节，确保了教学高水准。以1300系列（针对3岁－3岁半幼儿的课程）开学第一周的周教学计划为例，教案中除了有周主题和关联品格的设计外，每天三个集体教学活动、八个区角活动、两个小组活动（语言和数学）、两个户外活动，一周五天每天活动安排都明晰地设计出来，供教师备课时参考。</p>
        <div class="two">
          <img
            class="curr_img2"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img2.jpg"
          >
          <div v-show="this.$store.state.isMobile" class="curr_img2_bg"></div>
          <img
            class="curr_img3"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img3.png"
          >
        </div>
        <p
          id="second"
        >Kids 'R' Kids的课程历经半个世纪的探索实践，仍在不断修订完善。美国总部的研发团队，专职于课程的开发与设计，历经50余年的反复打磨，让课程体系日益成熟，与时俱进。</p>
      </div>
      <div class="learning">
        <h1>Academic learning</h1>
        <h3 v-show="!this.$store.state.isMobile">
          0-6岁全套幼儿园课程——
          <span id="span">填补0-2岁课程空白</span>
        </h3>
        <h3 v-show="this.$store.state.isMobile">
          0-6岁全套幼儿园课程
          <span id="span"><i>——</i>填补0-2岁课程空白</span>
        </h3>
        <p>在Kids 'R' Kids, 我们认为孩子就是孩子，要尊重孩子的生命发展规律——通过愉快的玩耍启动大脑的学习机关。我们的课程设置涵盖艺术、建构、文学、戏剧、数学、写作、手工、音乐、科学、感知，以及户外探索，让孩子们快乐成长的同时平衡发展。</p>
        <div class="five">
          <img
            class="curr_img4"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img4.jpg"
          >
          <img
            class="curr_img5"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img5.jpg"
          >
          <img
            class="curr_img6"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img6.jpg"
          >
          <img
            class="curr_img7"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img7.jpg"
          >
          <div class="center">
            <img
              class="curr_img8"
              src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img8.png"
            >
          </div>
        </div>
        <p
          id="second"
        >Kids 'R' Kids拥有从6星期（1个半月龄）到6岁的幼儿园课程体系，让孩子从出生就能接受完整、系统、连贯的教育，填补了0-2岁幼儿园课程空白。Kids 'R' Kids的First Class™核心课程涵盖Big Steps™ 和Fast Track™，针对0-1岁、1-3岁和3-6岁三个年龄段，是幼儿园基本课程，培养孩子的社交情感、动作、认知、语言等多项能力。除此之外，Kids 'R' Kids还拥有具备专项教育目标的特色课程。如针对6星期-5岁的Brain Waves™脑开发课程、针对3-6岁的STEAM Ahead™跨学科课程、针对1-6岁的HiChina母语课程（其中含KG班学科课程），以及每年更换主题的短期SUMMER CAMP夏令营课程。</p>
        <div class="four">
          <p>与美国课程同步的Kids 'R' Kids主体课程——核心课程</p>
          <p id="year">6周~6岁</p>
          <img
            class="curr_bigsteps1"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_bigsteps1.png"
          >
          <img
            class="curr_bigsteps2"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_bigsteps.png"
          >
          <img
            class="curr_fasttrack"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_fasttrack.png"
          >
          <img
            class="curr_icon5"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_icon5.png"
          >
        </div>
        <div class="pic">
          <img
            class="curr_hichina"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_hichina.png"
          >
          <img
            class="curr_brainwaves"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_brainwaves.png"
          >
          <img
            class="curr_steamahead"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_steamahead.png"
          >
          <img
            class="curr_camp"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_camp.png"
          >
          <ul>
            <li>
              <p class="zwkc">中文课程 HiChina</p>
              <p class="onesix">1岁~6岁</p>
            </li>
            <li>
              <p class="kfkc">脑开发课程 Brain Waves</p>
              <p class="sixfive">6周~5岁</p>
            </li>
            <li>
              <p class="xkkc">跨学科课程 STEAM Ahead</p>
              <p class="threesix">3岁~6岁</p>
            </li>
            <li>
              <p class="xly">夏令营课程 Summer Camp</p>
              <p class="threeys">3岁以上</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="trend">
        <h1>Keep pace with global trend</h1>
        <h3>
          与美国同步课程——
          <span id="span">对接国际教育</span>
        </h3>
        <p>Kids 'R' Kids在中国的课程与美国160多家幼儿园保持同步，完美对接国际教育。在培养孩子心智成长和身体发展的同时，我们格外注重幼儿的情绪管理、社会融入以及品格塑造，致力于培养孩子独立自主、积极乐观、以及探究精神，为孩子从小培养全球化视野。Kids ‘R’ Kids美国总部每年结合社会热点设计的夏令营课程，更是让孩子从小接触多元文化，做世界的小公民。比如2016年的夏令营课程，便是以里约奥运会为主题进行设计。</p>
        <img
          class="curr_img11"
          src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img11.jpg"
        >
        <div class="pace">
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img9.jpg">
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img10.jpg">
        </div>
        <div class="create">
          <p
            id="second"
          >Kids 'R' Kids注重对孩子创造力和审美能力的培养。我们为幼儿提供丰富的手工材料，营造更适合孩子想象力发展的活动空间，鼓励他们用不同的方式去探索和学习。个性化的学习过程丰富了孩子在Kids 'R' Kids每一个发展阶段的体验，更好对接国际教育。</p>
          <div class="hand">
            <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img12.jpg">
            <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img13.jpg">
          </div>
        </div>
      </div>
      <div class="chinese">
        <h1>Chinese Curriculum</h1>
        <h3>
          独创中文课程——
          <span id="span">培养中英双语能力</span>
        </h3>
        <p>Kids 'R' Kids中国研发团队拥有雄厚的学术背景，团队成员大多来自美国藤校的教育、心理相关专业。为了适应中国本土化教育需求，Kids 'R' Kids联合外部专家，共同打造出基于核心课程体系的中文课程，涵盖中国传统节日、二十四节气、文化习俗等，以实现我们培养孩子立足本土文化，具有国际视野的发展目标。</p>
        <div class="pics">
          <img
            class="curr_img14"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img14.jpg"
          >
          <img
            class="curr_img15"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img15.jpg"
          >
          <img
            class="curr_img16"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img16.jpg"
          >
          <img
            class="curr_img17"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img17.jpg"
          >
          <img
            class="curr_img18"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img18.png"
          >
        </div>
        <div class="cae">
          <p
            id="second"
          >全英文教学+中文特色课程，为孩子从小营造浸入式的双语环境，让孩子不仅练就一口地道的英文，更能培养中国文化底蕴。此外，为KG毕业班量身打造的学科课程，助力幼儿未来学业发展。</p>
          <img
            class="curr_img19"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_img19.jpg"
          >
        </div>
      </div>
    </div>
    <div class="person_wrap">
      <div class="person">
        <div class="color">
          <p>Kids 'R' Kids独创课程体系以两大核心课程为中心，融入四大特色课程。英文课程全部和美国Kids 'R' Kids同步，全面接轨国际教育理念和实践。在中国，我们培养KRK宝贝具有以下十二大核心能力。</p>
        </div>
        <div class="allFonts">
          <!-- <span class="Empathy">Empathy</span>
          <span class="Collaboration">Collaboration</span>
          <span class="Confidence">Confidence</span>
          <span class="Perseverance">Perseverance</span>
          <span class="Gratitude">Gratitude</span>
          <span class="Citizenship">Citizenship</span>
          <span class="Integrity">Integrity</span>
          <span class="Leadership">Leadership</span>
          <span class="Insightfulness">Insightfulness</span>
          <span class="Ingenuity">Ingenuity</span>
          <span class="Self-Mastery">Self-Mastery</span>
          <span class="Proactiveness">Proactiveness</span> -->
        </div>
        <!-- <span class="CORE">CORE
          <br>COMPETENCY
        </span> -->
      </div>
    </div>
    <div class="child_wrap">
      <div class="child">
        <div class="three">
          <img
            class="BigStepLogoinfant"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/BigStepLogoinfant.png"
          >
          <img
            class="BigStepLogotoddler"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/BigStepLogotoddler.png"
          >
          <img
            class="FastTrackLogo"
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/FastTrackLogo.png"
          >
        </div>
        <div class="bottomFour">
          <img
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/Brain%20Waves%20corp.png"
          >
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/STEAMlogo1-RGB.png">
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/hi%20china.png">
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/camp.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  mounted () {},
  components: {},
  methods: {}
}
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.course-section {
  width: 100%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  .w1200 {
    width: 1200px !important;
    margin: 0 auto;
  }
  .header {
    width: 1200px;
    height: 155px;
    overflow: hidden;
    margin-top: 110px;
    .header-left {
      float: left;
      .hr {
        width: 96px;
        height: 4px;
        background: rgba(174, 149, 79, 1);
      }
      h2 {
        width: 375px;
        height: 96px;
        font-size: 48px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 96px;
      }
      h3 {
        width: 180px;
        height: 29px;
        line-height: 29px;
        background: rgba(174, 149, 79, 1);
        font-size: 24px;
        font-family: TimesNewRomanPS-BoldItalicMT;
        font-weight: bold;
        font-style: italic;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
    .header-right {
      float: left;
      width: 390px;
      margin-top: 16px;
      margin-left: 430px;
      height: 73px;
      font-size: 73px;
      font-family: TimesNewRomanPS-ItalicMT;
      font-style: italic;
      color: rgba(204, 204, 204, 1);
      line-height: 73px;
      text-align: right;
    }
  }
  .allContent_wrap {
    width: 100%;
    height: 722px;
    margin: 0 auto;
    background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_bg1.jpg)
      no-repeat 122px 0px;
    background-size: 714px 855px;
    .allContent {
      margin: 0 auto;
      width: 1200px;
      height: 722px;
      p {
        width: 733px;
        height: 112px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        padding-top: 47px;
        padding-bottom: 81px;
      }
      .allContent_right {
        width: 900px;
        height: 173px;
        background: rgba(0, 52, 120, 1);
        float: right;
        text-align: center;
        position: relative;
        .span {
          width: 100%;
          height: 23px;
          font-size: 24px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          line-height: 32px;
        }
        img {
          width: 142px;
          height: 185px;
        }
        .img1 {
          position: absolute;
          top: 97px;
          left: 108px;
          width: 142px;
          height: 257px;
          text-align: center;
          p {
            width: 100%;
            height: 15px;
            text-align: center;
            font-size: 16px;
            font-family: ArialMT;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 32px;
            padding-bottom: 10px;
            padding-top: 17px;
          }
          span {
            position: absolute;
            top: 239px;
            left: 58px;
            width: 24px;
            height: 2px;
            display: block;
            background: rgba(174, 149, 79, 1);
            margin-bottom: 10px;
          }
          h5 {
            width: 100%;
            height: 16px;
            font-size: 16px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 32px;
            margin-top: 22px;
          }
        }
        .img2 {
          position: absolute;
          top: 97px;
          left: 380px;
          width: 142px;
          height: 257px;
          text-align: center;
          p {
            width: 100%;
            height: 15px;
            text-align: center;
            font-size: 16px;
            font-family: ArialMT;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 32px;
            padding-bottom: 10px;
            padding-top: 17px;
          }
          span {
            position: absolute;
            top: 239px;
            left: 58px;
            width: 24px;
            height: 2px;
            display: block;
            background: rgba(174, 149, 79, 1);
            margin-bottom: 10px;
          }
          h5 {
            width: 100%;
            height: 16px;
            font-size: 16px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 32px;
            margin-top: 22px;
          }
        }
        .img3 {
          position: absolute;
          top: 97px;
          left: 650px;
          width: 142px;
          height: 257px;
          text-align: center;
          p {
            width: 100%;
            height: 15px;
            text-align: center;
            font-size: 16px;
            font-family: ArialMT;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 32px;
            padding-bottom: 10px;
            padding-top: 17px;
          }
          span {
            position: absolute;
            top: 239px;
            left: 58px;
            width: 24px;
            height: 2px;
            display: block;
            background: rgba(174, 149, 79, 1);
            margin-bottom: 10px;
          }
          h5 {
            width: 100%;
            height: 16px;
            font-size: 16px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 32px;
            margin-top: 22px;
          }
        }
      }
    }
  }
  .blue_wrap {
    width: 100%;
    height: 660px;
    background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_bg2.jpg)
      no-repeat;
    margin: 0 auto;
    .blue {
      width: 1200px;
      height: 660px;
      margin: 0 auto;
      text-align: center;
      p {
        width: 100%;
        height: 37px;
        font-size: 40px;
        font-family: TimesNewRomanPS-ItalicMT;
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
        line-height: 32px;
        padding-top: 149px;
        padding-bottom: 47px;
      }
      .feature {
        width: 100%;
        height: 54px;
        padding: 0;
        opacity: 0.8;
        font-size: 24px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 54px;
        text-align: center;
        span {
          width: 400px;
          text-align: center;
          height: 54px;
          display: inline-block;
          background: rgba(196, 141, 10, 1);
        }
      }
      .square {
        width: 1200px;
        height: 110px;
        background: #fff;
        margin-top: 263px;
        position: relative;
        .square1 {
          width: 221px;
          height: 245px;
          background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_six1.png);
          background-size: 221px 245px;
          position: absolute;
          top: -147px;
          left: 108px;
          img {
            width: 66px;
            height: 66px;
            margin-top: 20px;
          }
          p {
            width: 100%;
            height: 20px;
            font-size: 20px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
            padding-top: 20px;
            padding-bottom: 15px;
          }
          span {
            display: inline-block;
            width: 100%;
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
          }
          i {
            display: inline-block;
            width: 100%;
            height: 14px;
            font-size: 16px;
            font-family: TimesNewRomanPS-ItalicMT;
            font-weight: normal;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
            margin-top: 5px;
          }
        }
        .square2 {
          width: 221px;
          height: 245px;
          background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_six2.png);
          background-size: 221px 245px;
          position: absolute;
          top: -147px;
          left: 361px;
          img {
            width: 66px;
            height: 66px;
            margin-top: 20px;
          }
          p {
            width: 100%;
            height: 20px;
            font-size: 20px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
            padding-top: 20px;
            padding-bottom: 15px;
          }
          span {
            display: inline-block;
            width: 100%;
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
          }
          i {
            display: inline-block;
            width: 100%;
            height: 14px;
            font-size: 16px;
            font-family: TimesNewRomanPS-ItalicMT;
            font-weight: normal;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
            margin-top: 5px;
          }
        }
        .square3 {
          width: 221px;
          height: 245px;
          background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_six2.png);
          background-size: 221px 245px;
          position: absolute;
          top: -147px;
          left: 615px;
          img {
            width: 66px;
            height: 66px;
            margin-top: 20px;
          }
          p {
            width: 100%;
            height: 20px;
            font-size: 20px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
            padding-top: 20px;
            padding-bottom: 15px;
          }
          span {
            display: inline-block;
            width: 100%;
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
          }
          i {
            display: inline-block;
            width: 100%;
            height: 14px;
            font-size: 16px;
            font-family: TimesNewRomanPS-ItalicMT;
            font-weight: normal;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
            margin-top: 5px;
          }
        }
        .square4 {
          width: 221px;
          height: 245px;
          background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_six2.png);
          background-size: 221px 245px;
          position: absolute;
          top: -147px;
          left: 870px;
          img {
            width: 66px;
            height: 66px;
            margin-top: 20px;
          }
          p {
            width: 100%;
            height: 20px;
            font-size: 20px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
            padding-top: 20px;
            padding-bottom: 15px;
          }
          span {
            display: inline-block;
            width: 100%;
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
          }
          i {
            display: inline-block;
            width: 100%;
            height: 14px;
            font-size: 16px;
            font-family: TimesNewRomanPS-ItalicMT;
            font-weight: normal;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
            margin-top: 5px;
          }
        }
      }
    }
  }
  .practice_wrap {
    width: 100%;
    min-height: 1000px;
    background: #fff;
    margin: 0 auto;
    .practice {
      width: 980px;
      height: auto;
      margin: 0 auto;
      padding: 0px 110px;
      h1 {
        width: 100%;
        height: 37px;
        font-size: 40px;
        font-family: TimesNewRomanPSMT;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 32px;
        padding-top: 55px;
        padding-bottom: 15px;
      }
      h3 {
        width: 450px;
        height: 23px;
        font-size: 24px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        #span {
          width: 167px;
          height: 24px;
          font-size: 24px;
          font-weight: 400;
          color: #ae954f;
          line-height: 32px;
        }
      }
      p {
        padding-top: 59px;
        padding-bottom: 9px;
        width: 982px;
        height: 80px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
      }
      img {
        width: 643px;
        height: 354px;
        margin-left: 141px;
      }
      #second {
        width: 982px;
        height: 112px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        padding-top: 24px;
        padding-bottom: 42px;
      }
      .two {
        width: 768px;
        height: 285px;
        background: rgba(174, 149, 79, 1);
        margin-left: 106px;
        margin-bottom: 71px;
        position: relative;
        img {
          width: 450px;
          height: 285px;
        }
        .curr_img2 {
          position: absolute;
          top: 0;
          left: -142px;
        }
        .curr_img3 {
          width: 316px;
          height: 226px;
          position: absolute;
          top: 36px;
          right: 43px;
        }
      }
    }
    .learning {
      width: 980px;
      height: auto;
      margin: 0 auto;
      padding: 0px 110px;
      h1 {
        width: 100%;
        height: 37px;
        font-size: 40px;
        font-family: TimesNewRomanPSMT;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 32px;
        padding-top: 55px;
        padding-bottom: 15px;
      }
      h3 {
        width: 650px;
        height: 23px;
        font-size: 24px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        #span {
          width: 167px;
          height: 24px;
          font-size: 24px;
          font-weight: 400;
          color: #ae954f;
          line-height: 32px;
        }
      }
      p {
        padding-top: 59px;
        padding-bottom: 6px;
        width: 982px;
        height: 72px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
      }
      .five {
        width: 745px;
        height: 520px;
        margin-left: 106px;
        margin-top: 47px;
        position: relative;
        z-index: 1;
        background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/bg.png)
          no-repeat center center;
        img {
          width: 296px;
          height: 200px;
          z-index: 1;
        }
        .curr_img4 {
          position: absolute;
          top: 0;
          left: 0;
        }
        .curr_img5 {
          position: absolute;
          right: 0;
          top: 0;
        }
        .curr_img6 {
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .curr_img7 {
          position: absolute;
          right: 0;
          bottom: 0;
        }
        .center {
          position: absolute;
          width: 344px;
          height: 249px;
          left: 205px;
          top: 139px;
          z-index: 1;
          .curr_img8 {
            position: absolute;
            left: 16px;
            top: 20px;
            width: 312px;
            height: 216px;
            z-index: 2;
          }
        }
      }
      #second {
        width: 982px;
        height: 112px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        padding-top: 66px;
        padding-bottom: 84px;
      }
      .four {
        width: 729px;
        height: 216px;
        background: rgba(242, 250, 255, 1);
        margin-left: 110px;
        margin-bottom: 38px;
        margin-top: 50px;
        text-align: center;
        position: relative;
        p {
          width: 100%;
          height: 13px;
          font-size: 12px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(0, 52, 120, 1);
          line-height: 16px;
          position: absolute;
          bottom: 43px;
        }
        #year {
          bottom: 23px;
          padding: 0px;
        }
        img {
          width: 149px;
          height: 81px;
        }
        .curr_bigsteps1 {
          position: absolute;
          top: 57px;
          left: 46px;
        }
        .curr_bigsteps2 {
          position: absolute;
          top: 57px;
          left: 285px;
        }
        .curr_fasttrack {
          position: absolute;
          top: 57px;
          left: 544px;
        }
        .curr_icon5 {
          position: absolute;
          top: -34px;
          left: 276px;
          width: 176px;
          height: 66px;
        }
      }
      .pic {
        width: 900px;
        height: 155px;
        position: relative;
        margin-bottom: 129px;
        img {
          width: 169px;
          height: 90px;
        }
        .curr_hichina {
          position: absolute;
          top: 0;
          left: 20px;
        }
        .curr_brainwaves {
          position: absolute;
          top: 0;
          left: 262px;
          width: 169px;
          height: 78px;
        }
        .curr_steamahead {
          position: absolute;
          top: -5px;
          left: 511px;
          width: 164px;
          height: 94px;
        }
        .curr_camp {
          position: absolute;
          top: 0;
          left: 776px;
          width: 122px;
          height: 89px;
        }
        ul {
          width: 900px;
          height: 50px;
          background: rgba(242, 250, 255, 1);
          position: absolute;
          bottom: 0;
          left: 30px;
          li {
            float: left;
            width: 225px;
            height: 50px;
            p {
              width: auto;
              height: 12px;
              font-size: 12px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              color: rgba(0, 52, 120, 1);
              line-height: 16px;
              padding-top: 9px;
              padding-bottom: 7px;
              margin-left: 36px;
            }
            p:last-child {
              padding: 0px;
              margin-left: 62px;
            }
          }
          li:first-child {
            p:first-child {
              margin-left: 15px;
            }
            p:last-child {
              margin-left: 42px;
            }
          }
          li:nth-child(2) {
            p:first-child {
              margin-left: 15px;
            }
          }
          li:nth-child(3) {
            p:last-child {
              margin-left: 82px;
            }
          }
          li:last-child {
            p:first-child {
              margin-left: 40px;
            }
            p:last-child {
              margin-left: 102px;
            }
          }
        }
      }
      .two {
        width: 768px;
        height: 285px;
        background: rgba(174, 149, 79, 1);
        margin-left: 106px;
        margin-bottom: 71px;
        position: relative;
        img {
          width: 450px;
          height: 285px;
        }
        .curr_img2 {
          position: absolute;
          top: 0;
          left: -142px;
        }
        .curr_img3 {
          width: 316px;
          height: 226px;
          position: absolute;
          top: 36px;
          right: 43px;
        }
      }
    }
    .trend {
      width: 980px;
      height: auto;
      margin: 0 auto;
      padding: 0px 110px;
      position: relative;
      h1 {
        width: 100%;
        height: 37px;
        font-size: 40px;
        font-family: TimesNewRomanPSMT;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 32px;
        padding-top: 55px;
        padding-bottom: 15px;
      }
      h3 {
        width: 450px;
        height: 23px;
        font-size: 24px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        #span {
          width: 167px;
          height: 24px;
          font-size: 24px;
          font-weight: 400;
          color: #ae954f;
          line-height: 32px;
        }
      }
      p {
        padding-top: 50px;
        padding-bottom: 64px;
        width: 597px;
        height: 140px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
      }
      .curr_img11 {
        width: 346px;
        height: 368px;
        margin-left: 42px;
        position: absolute;
        right: 110px;
        top: 223px;
      }
      .pace {
        width: 597px;
        height: 208px;
        img {
          height: 208px;
        }
        img:first-child {
          width: 341px;
        }
        img:last-child {
          float: right;
        }
      }
      .create {
        width: 982px;
        height: 113px;
        margin-bottom: 143px;
        .hand {
          width: 346px;
          height: 113px;
          float: right;
          margin-top: 58px;
          img {
            width: 176px;
            height: 113px;
          }
          img:last-child {
            float: right;
            width: 168px;
          }
        }
        #second {
          float: left;
          padding-bottom: 0px;
        }
      }
    }
    .chinese {
      width: 980px;
      height: auto;
      margin: 0 auto;
      padding: 0px 110px;
      position: relative;
      h1 {
        width: 100%;
        height: 37px;
        font-size: 40px;
        font-family: TimesNewRomanPSMT;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 32px;
        padding-top: 55px;
        padding-bottom: 15px;
      }
      h3 {
        width: 600px;
        height: 23px;
        font-size: 24px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        #span {
          width: 167px;
          height: 24px;
          font-size: 24px;
          font-weight: 400;
          color: #ae954f;
          line-height: 32px;
        }
      }
      p {
        padding-top: 59px;
        padding-bottom: 64px;
        width: 981px;
        height: 80px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
      }
      .pics {
        height: 360px;
        width: 770px;
        margin: 0 auto;
        position: relative;
        background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/xt.png)
          no-repeat center center;
        img {
          width: 187px;
          height: 135px;
        }
        .curr_img14 {
          position: absolute;
          top: 0;
          left: 0;
        }
        .curr_img15 {
          position: absolute;
          top: 0;
          right: 0;
        }
        .curr_img16 {
          position: absolute;
          bottom: 0;
          left: 0;
        }
        .curr_img17 {
          position: absolute;
          bottom: 0;
          right: 0;
        }
        .curr_img18 {
          position: absolute;
          top: 27px;
          right: 233px;
          width: 313px;
          height: 312px;
        }
      }
      .cae {
        width: 980px;
        height: 114px;
        margin-top: 71px;
        margin-bottom: 158px;
        #second {
          float: left;
          margin-bottom: 143px;
          width: 488px;
          height: 80px;
          padding: 0;
          padding-top: 15px;
        }
        .curr_img19 {
          width: 443px;
          height: 114px;
          float: right;
        }
      }
    }
  }
  .person_wrap {
    width: 100%;
    height: 1030px;
    background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_bg3.jpg)
      no-repeat;
    margin: 0 auto;
    .person {
      width: 1200px;
      height: 1030px;
      margin: 0 auto;
      position: relative;
      .color {
        width: 984px;
        height: 94px;
        background: rgba(255, 255, 255, 0.5);
        padding-top: 38px;
        padding-left: 96px;
        position: absolute;
        top: 68px;
        left: 110px;
        p {
          width: 776px;
          height: 49px;
          font-size: 16px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
        }
      }
      .allFonts {
        position: absolute;
        top: 257px;
        left: 273px;
        width: 657px;
        height: 653px;
        background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/1671587437978_.pic.jpg)
          no-repeat;
        background-size: 100% 100%;
        span {
          width: auto;
          height: 15px;
          font-size: 19px;
          font-family: AvenirNextCondensed-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 34px;
        }
        .Empathy {
          position: absolute;
          top: 45px;
          left: 298px;
        }
        .Collaboration {
          position: absolute;
          top: 82px;
          left: 415px;
        }
        .Confidence {
          position: absolute;
          top: 178px;
          left: 520px;
        }
        .Perseverance {
          position: absolute;
          top: 308px;
          left: 549px;
        }
        .Gratitude {
          position: absolute;
          top: 440px;
          left: 528px;
        }
        .Citizenship {
          position: absolute;
          top: 538px;
          left: 424px;
        }
        .Integrity {
          position: absolute;
          top: 575px;
          left: 300px;
        }
        .Leadership {
          position: absolute;
          top: 538px;
          left: 158px;
        }
        .Insightfulness {
          position: absolute;
          top: 443px;
          left: 50px;
        }
        .Ingenuity {
          position: absolute;
          top: 310px;
          left: 29px;
        }
        .Self-Mastery {
          position: absolute;
          top: 178px;
          left: 58px;
        }
        .Proactiveness {
          position: absolute;
          top: 80px;
          left: 150px;
        }
      }
      .CORE {
        width: 179px;
        height: 48px;
        font-size: 25px;
        text-align: center;
        font-family: TimesNewRomanPS-BoldMT;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 31px;
        position: absolute;
        top: 454px;
        left: 515px;
      }
    }
  }
  .child_wrap {
    width: 100%;
    height: 810px;
    background: rgba(0, 52, 120, 1);
    margin: 0 auto;
    .child {
      width: 1200px;
      height: 810px;
      margin: 0 auto;
      position: relative;
      .three {
        width: 1002px;
        height: 280px;
        position: absolute;
        top: 124px;
        left: 99px;
        background: rgba(1, 43, 98, 1);
        img {
          width: 285px;
          height: 200px;
        }
        .BigStepLogoinfant {
          position: absolute;
          top: 40px;
          left: 55px;
        }
        .BigStepLogotoddler {
          position: absolute;
          top: 40px;
          left: 360px;
        }
        .FastTrackLogo {
          position: absolute;
          top: 40px;
          left: 665px;
        }
      }
      .bottomFour {
        width: 1200px;
        height: 200px;
        position: absolute;
        bottom: 134px;
        left: 0;
        img {
          width: 286px;
          height: 200px;
        }
        img:nth-child(2) {
          position: absolute;
          top: 0;
          left: 306px;
        }
        img:nth-child(3) {
          position: absolute;
          top: 0;
          left: 612px;
        }
        img:nth-child(4) {
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .course-section {
    .w1200 {
      width: 100% !important;
    }
    .header {
      width: 100%;
      height: 64px;
      overflow: hidden;
      margin-top: 35px;
      margin-bottom: 35px;
      .header-left {
        width: 100%;
        box-sizing: border-box;
        padding-left: 7.7%;
        .hr {
          width: 56px;
          height: 3px;
        }
        h2 {
          width: 100%;
          height: 41px;
          font-size: 21px;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          font-family: PingFangSC-Medium;
          padding: 10px 0 8px;
          box-sizing: border-box;
        }
        h3 {
          width: 64px;
          height: 20px;
          font-size: 10px;
          font-family: TimesNewRomanPS-BoldItalicMT;
          font-weight: normal;
          line-height: 20px;
          background: rgba(174, 149, 79, 1);
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          padding: 0 5px;
        }
      }
      .header-right {
        display: none;
      }
    }
    .allContent_wrap {
      width: 100%;
      height: auto;
      margin: 0 auto;
      background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_bg1.jpg)
        no-repeat -34px 49px;
      background-size: 237px 302px;
      .allContent {
        margin: 0 auto;
        width: 100%;
        height: 536px;
        p {
          width: 100%;
          padding: 0 8.2%;
          box-sizing: border-box;
          height: 227px;
          font-size: 13px;
          font-family: Adobe Heiti Std R;
          font-weight: normal;
          line-height: 21px;
          padding-bottom: 62px;
        }
        .allContent_right {
          width: 80.8%;
          height: 89px;
          .span {
            width: 100%;
            height: 23px;
            font-size: 17px;
            line-height: 23px;
            margin-top: 19px;
          }
          img {
            width: 100%;
            height: auto;
          }
          .img1,
          .img2,
          .img3 {
            position: absolute;
            width: 28%;
            height: auto;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            p {
              width: 100%;
              height: 27px;
              font-size: 12px;
              line-height: 15px;
              padding-bottom: 0;
              margin-bottom: 5px;
              padding-top: 12px;
            }
            span {
              position: initial;
              width: 12px;
              height: 2px;
              margin-bottom: 5px;
            }
            h5 {
              width: 100%;
              height: 16px;
              font-size: 12px;
              font-family:PingFangSC-Regular;
              font-weight:400;
              line-height: 16px;
              margin-top: 0;
            }
          }
          .img1 {
            top: 60px;
            left: 14px;

          }
          .img2 {
            top: 60px;
            left: 112px;
          }
          .img3 {
            top: 60px;
            left: 208px;
            p {
              -webkit-text-size-adjust:none;
              font-size: 10px;
            }
          }
        }
      }
    }
    .blue_wrap {
      width: 100%;
      height: 270px;
      background-size: 787px 270px;
      background-position: 50% 0;
      .blue {
        width: 100%;
        height: 660px;
        p {
          width: 100%;
          height: 22px;
          font-size: 21px;
          line-height: 22px;
          padding-top: 43px;
          padding-bottom: 15px;
        }
        .feature {
          width: 100%;
          height: 32px;
          font-size: 13px;
          line-height: 32px;
          text-align: center;
          span {
            width: 37%;
            height: 32px;
          }
        }
        .square {
          width: 85%;
          height: 300px;
          display: flex;
          flex-wrap: wrap;
          margin: 0 auto;
          margin-top: 26px;
          // padding-top: 100px;
          box-sizing: border-box;
          justify-content: space-around;
          position: relative;
          background: rgba(0, 0, 0, 0);
          .square-bg {
            width: 100%;
          height: 265px;
          background: #fff;
            position: absolute;
            top: 85px;
            left: 0;
          }
          .square1, .square2, .square3, .square4 {
            width: 46%;
            height: 150px;
            position: initial;
            z-index: 9;
            margin-bottom: 25px;
            img {
              width: 33px;
              height: 33px;
              margin-top: 10px;
            }
            p {
              width: 100%;
              height: 12px;
              font-size: 12px;
              line-height: 12px;
              padding: 0;
              margin-top: 10px;
              margin-bottom: 7px;
            }
            span {
              display: inline-block;
              width: 100%;
              height: 12px;
              font-size: 10px;
              line-height: 12px;
              margin-bottom: 7px;
            }
            i {
              display: inline-block;
              width: 100%;
              height: 12px;
              font-size: 10px;
              line-height: 12px;
              margin-top: 0;
            }
          }
          .square1 {
            background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_six1.png);
            background-size: 100% 150px;
          }
          .square2 {
            background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_six2.png);
            background-size: 100% 150px;
          }
          .square3 {
            background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_six2.png);
            background-size: 100% 150px;
          }
          .square4 {
            background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_six2.png);
            background-size: 100% 150px;
          }
        }
      }
    }
    .practice_wrap {
      width: 100%;
      min-height: 1000px;
      background: #fff;
      margin: 0 auto;
      margin-top: 200px;
      .practice {
        width: 100%;
        height: auto;
        padding: 0px;
        h1 {
          width: 100%;
          box-sizing: border-box;
          height: 46px;
          font-size: 21px;
          line-height: 26px;
          padding: 13px 0 7px  7.8%;
        }
        h3 {
          width: 100%;
          box-sizing: border-box;
          padding-left: 7.7%;
          height: 22px;
          font-size: 18px;
          font-family:PingFangSC-Medium;
          font-weight: 500;
          line-height: 22px;
          margin-bottom: 23px;
          #span {
            width: auto;
            height: 22px;
            font-size: 18px;
            font-family:PingFangSC-Medium;
            font-weight: 500;
            line-height: 22px;
          }
        }
        p {
          padding: 0 7.7% 20px 8.2%;
          width: 100%;
          box-sizing: border-box;
          height: 145px;
          font-size: 13px;
          font-family:PingFangSC-Regular;
          line-height: 21px;
        }
        img {
          width: 83.6%;
          height: auto;
          margin-left: 8.2%;
        }
        #second {
          width: 100%;
          box-sizing: border-box;
          height: 245px;
          font-size: 13px;
          font-family:PingFangSC-Regular;
          line-height: 21px;
          padding: 31px 8% 45px 8.3%;
        }
        #second:last-child {
          height: 160px;
        }
        .two {
          width: 100%;
          padding: 0 7.7% 0 7.7%;
          box-sizing: border-box;
          height: 303px;
          background: none;
          margin-left: 0;
          margin-bottom: 0;
          position: relative;
          .curr_img2_bg {
            width: 100%;
            height: 101px;
            background: rgba(174, 149, 79, 1);
            float: left;
          }
          img {
            width: 100%;
            height: auto;
            float: left;
          }
          .curr_img2 {
            margin: 0;
            position: initial;
          }
          .curr_img3 {
            width: 54.4%;
            height: auto;
            position: absolute;
            top: 148px;
            right: 16%;
          }
        }
      }
      .learning {
        width: 100%;
        height: auto;
        margin: 0 auto;
        padding: 0;
        h1 {
          width: 100%;
          box-sizing: border-box;
          height: 46px;
          font-size: 21px;
          line-height: 26px;
          padding: 13px 0 7px  7.8%;
        }
        h3 {
          width: 100%;
          box-sizing: border-box;
          padding:0 7.7%;
          height: 44px;
          font-size: 18px;
          font-family:PingFangSC-Medium;
          font-weight: 500;
          line-height: 22px;
          margin-bottom: 23px;
          position: relative;
          #span {
            width: auto;
            height: 22px;
            font-size: 18px;
            font-family:PingFangSC-Medium;
            font-weight: 500;
            line-height: 22px;
            position: absolute;
            right: 7.7%;
            bottom: -6px;
            i {
              color: #333;
            }
          }
        }
        p {
          padding: 0 7.7% 30px 8.2%;
          width: 100%;
          box-sizing: border-box;
          height: 135px;
          font-size: 13px;
          font-family:PingFangSC-Regular;
          line-height: 21px;
        }
        .five {
          width: 100%;
          box-sizing: border-box;
          height: 222px;
          padding: 0 7.4%;
          margin-left: 0;
          margin-top: 0;
          margin-bottom: 44px;
          position: relative;
          z-index: 1;
          background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/bg.png)
            no-repeat center center;
            background-size: 40% 48%;
          img {
            width: 34%;
            height: auto;
            z-index: 1;
          }
          .curr_img4 {
            position: absolute;
            top: 0;
            left: 7.4%;
          }
          .curr_img5 {
            position: absolute;
            right: 7.4%;
            top: 0;
          }
          .curr_img6 {
            position: absolute;
            left: 7.4%;
            bottom: 0;
          }
          .curr_img7 {
            position: absolute;
            right: 7.4%;
            bottom: 0;
          }
          .center {
            position: absolute;
            left:0;
            top: 0;
            width: 100%;
            z-index: 3;
            .curr_img8 {
              position: absolute;
              width: 36%;
              height: auto;
              left: 50%;
              top: 27%;
              margin-left: -18%;
            }
          }
        }
        #second {
          width: 100%;
          box-sizing: border-box;
          padding: 0 8.1%;
          font-family:PingFangSC-Regular;
          height: 252px;
          font-size: 13px;
          line-height: 21px;
          padding-top: 0;
          padding-bottom: 0;
        }
        .four {
          width: 84.6%;
          margin: 35px  7.7% 0;
          padding: 0;
          height: 150px;
          background: rgba(242, 250, 255, 1);
          position: relative;
          p {
            width: 100%;
            height: 12px;
            font-size: 10px;
            line-height: 12px;
            position: absolute;
            bottom: 24px;
            padding: 0;
          }
          #year {
            bottom: 7px;
            padding: 0px;
          }
          img {
            width: 27.3%;
            height: auto;
          }
          .curr_bigsteps1 {
            position: absolute;
            top: 40px;
            left: 6%;
          }
          .curr_bigsteps2 {
            position: absolute;
            top: 40px;
            left: 38.5%;
          }
          .curr_fasttrack {
            position: absolute;
            top: 40px;
            left: 71.3%;
          }
          .curr_icon5 {
            position: absolute;
            top: -16px;
            left: 50%;
            margin-left: -15.7%;
            width: 31.4%;
            height: auto;
          }
        }
        .pic {
          margin-top: 27px;
          width: 100%;
          height: 240px;
          box-sizing: border-box;
          padding: 0 7.7% 0 8%;
          position: relative;
          margin-bottom: 54px;
          img {
            width: 25%;
            height: auto;
          }
          .curr_hichina {
            position: absolute;
            top: 0;
            left: 20%;
          }
          .curr_brainwaves {
            position: absolute;
            top: 1%;
            left: 57.3%;
            width: 25%;
            height: auto;
          }
          .curr_steamahead {
            position: absolute;
            top: 58%;
            left: 20.4%;
            width: 24%;
            height: auto;
          }
          .curr_camp {
            position: absolute;
            top: 58%;
            left: 60.8%;
            width: 17.9%;
            height: auto;
          }
          ul {
            width: 84.3%;
            height: 76px;
            background: none;
            position: absolute;
            bottom: 0;
            left: 8%;
            li {
              position: absolute;
              width: 50%;
              height: 38px;
              background: rgba(242, 250, 255, 1);
              p {
                width: auto;
                height: 12px;
                font-size: 10px;
                line-height: 12px;
                padding: 0;
                margin-top: 5px;
                margin-bottom: 3px;
                margin-left: 0;
                text-align: center;
              }
              p:last-child {
                padding: 0px;
                margin-left: 0;
              }
            }
            li:first-child {
              top: -131%;
              left: 0;
              p:first-child {
                margin-left: 0;
              }
              p:last-child {
                margin-left: 0;
              }
            }
            li:nth-child(2) {
              top: -131%;
              right: 0;
              p:first-child {
                margin-left: 0;
              }
            }
            li:nth-child(3) {
              top: 56%;
              left: 0;
              p:last-child {
                margin-left: 0;
              }
            }
            li:last-child {
              top: 56%;
              right: 0;
              p:first-child {
                margin-left: 0;
              }
              p:last-child {
                margin-left: 0;
              }
            }
          }
        }
        .two {
          width: 768px;
          height: 285px;
          background: rgba(174, 149, 79, 1);
          margin-left: 106px;
          margin-bottom: 71px;
          position: relative;
          img {
            width: 450px;
            height: 285px;
          }
          .curr_img2 {
            position: absolute;
            top: 0;
            left: -142px;
          }
          .curr_img3 {
            width: 316px;
            height: 226px;
            position: absolute;
            top: 36px;
            right: 43px;
          }
        }
      }
      .trend {
        width: 100%;
        height: auto;
        margin: 0 auto;
        padding: 0px;
        h1 {
          width: 100%;
          box-sizing: border-box;
          height: 33px;
          font-size: 21px;
          line-height: 26px;
          padding: 0 0 7px  7.8%;
        }
        h3 {
          width: 100%;
          box-sizing: border-box;
          padding-left: 7.7%;
          height: 22px;
          font-size: 18px;
          font-family:PingFangSC-Medium;
          font-weight: 500;
          line-height: 22px;
          margin-bottom: 23px;
          #span {
            width: auto;
            height: 22px;
            font-size: 18px;
            font-family:PingFangSC-Medium;
            font-weight: 500;
            line-height: 22px;
          }
        }
        p {
          padding: 0 7.7% 20px 8.2%;
          width: 100%;
          box-sizing: border-box;
          height: 210px;
          font-size: 13px;
          font-family:PingFangSC-Regular;
          line-height: 21px;
        }
        .curr_img11 {
          width: 84.1%;
          height: auto;
          margin-left: 0;
          position: absolute;
          right: 8%;
          top: 142%;
        }
        .pace {
          width: 100%;
          height: auto;
          box-sizing: border-box;
          padding: 0 7.8%;
          margin-bottom: 37px;
          img {
            height: auto;
          }
          img:first-child {
            width: 57%;
          }
          img:last-child {
            width: 42%;
            float: right;
          }
        }
        .create {
          width: 100%;
          height: auto;
          margin-bottom: 0;
          .hand {
            display: none;
          }
          #second {
            float: left;
            height: 106px;
            padding-bottom: 0px;
            margin-bottom: 24px;
          }
        }
      }
      .chinese {
        width: 100%;
        padding: 0px;
        margin-top: 530px;
        h1 {
          width: 100%;
          box-sizing: border-box;
          height: 33px;
          font-size: 21px;
          line-height: 26px;
          padding: 0 0 7px  7.8%;
        }
        h3 {
          width: 100%;
          box-sizing: border-box;
          padding-left: 7.7%;
          height: 22px;
          font-size: 18px;
          font-family:PingFangSC-Medium;
          font-weight: 500;
          line-height: 22px;
          margin-bottom: 23px;
          #span {
            width: auto;
            height: 22px;
            font-size: 18px;
            font-family:PingFangSC-Medium;
            font-weight: 500;
            line-height: 22px;
          }
        }
        p {
          padding: 0 7.7% 20px 8.2%;
          width: 100%;
          box-sizing: border-box;
          height: 146px;
          font-size: 13px;
          font-family:PingFangSC-Regular;
          line-height: 21px;
        }
        .pics {
          height: 160px;
          width: 100%;
          margin: 0 auto;
          position: relative;
          background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/xt.png)
            no-repeat center center;
          background-size: 47% 68%;
          img {
            width: 20.5%;
            height: auto;
          }
          .curr_img14 {
            position: absolute;
            top: 0;
            left: 7.7%;
          }
          .curr_img15 {
            position: absolute;
            top: 0;
            right: 7.7%;
          }
          .curr_img16 {
            position: absolute;
            bottom: 0;
            left: 7.7%;
          }
          .curr_img17 {
            position: absolute;
            bottom: 0;
            right: 7.7%;
          }
          .curr_img18 {
            position: absolute;
            top: 11px;
            left: 33.5%;
            width: 34.4%;
            height: auto;
          }
        }
        .cae {
          width: 100%;
          height: 178px;
          margin-top: 40px;
          margin-bottom: 39px;
          #second {
            float: left;
            margin-bottom: 15px;
            width: 100%;
            height: 80px;
            padding: 0 8%;
          }
          .curr_img19 {
            width: 85%;
            height: auto;
            clear: both;
            margin:0 7.5%;
          }
        }
      }
    }
    .person_wrap {
      width: 100%;
      height: 550px;
      background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_bg3.jpg)
        no-repeat;
        background-size: 960px 550px;
        background-position: 43% 0%;
        margin: 0 auto;
      .person {
        width: 100%;
        height: auto;
        margin: 0 auto;
        position: relative;
        .color {
          width: 85%;
          height: 122px;
          margin: 0 7.4%;
          position: absolute;
          top: 35px;
          left: 0;
          padding: 0;
          p {
            width: 100%;
            padding: 14px 8.8% 17px 6.4%;
            box-sizing: border-box;
            height: 122px;
            font-size: 10px;
            line-height: 18px;
          }
        }
        .allFonts {
          position: absolute;
          top: 180px;
          left: 7.8%;
          width: 84.4%;
          height: 340px;
          background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/1671587437978_.pic.jpg)
            no-repeat;
          background-size: 100% 100%;
          background-position: 0% 0%;
          span {
            width: auto;
            height: 15px;
            font-size: 10px;
            line-height: 15px;
          }
          .Empathy {
            top: 26px;
            left: 44.5%;
          }
          .Collaboration {
            top: 45px;
            left: 63%;
          }
          .Confidence {
            top: 93px;
            left: 78%;
          }
          .Perseverance {
            top: 164px;
            left: 83%;
          }
          .Gratitude {
            top: 232px;
            left: 79.5%;
          }
          .Citizenship {
            top: 284px;
            left: 64%;
          }
          .Integrity {
            top: 300px;
            left: 45%;
          }
          .Leadership {
            top: 284px;
            left: 24%;
          }
          .Insightfulness {
            top: 232px;
            left: 7.5%;
          }
          .Ingenuity {
            top: 164px;
            left: 4%;
          }
          .Self-Mastery {
            top: 93px;
            left: 7.5%;
          }
          .Proactiveness {
            top: 45px;
            left: 22%;
          }
        }
        .CORE {
          display: none;
        }
      }
    }
    .child_wrap {
      width: 100%;
      height: 400px;
      .child {
        width: 100%;
        height: 400px;
        margin: 0 auto;
        position: relative;
        .three {
          width: 92.8%;
          height: 95px!important;
          position: absolute;
          top: 44px;
          left: 3.6%;
          background: rgba(1, 43, 98, 1);
          box-sizing: border-box;
          padding: 14px 5.3%;
          display: flex;
          justify-content: space-between;
          margin-bottom: 25px;
          img {
            width: 31.4%;
            height: auto;
          }
          .BigStepLogoinfant {
            position: initial;
          }
          .BigStepLogotoddler {
            position: initial;
          }
          .FastTrackLogo {
            position: initial;
          }
        }
        .bottomFour {
          width: 100%;
          height: 56%;
          position: absolute;
          bottom: 0;
          left: 0;
          img {
            width: 26.5%;
            height: auto;
          }
          img:nth-child(1) {
            position: absolute;
            top: 0;
            left: 23.2%;
          }
          img:nth-child(2) {
            position: absolute;
            top: 0;
            left: 54.4%;
          }
          img:nth-child(3) {
            position: absolute;
            top: 39%;
            left: 23.2%;
          }
          img:nth-child(4) {
            position: absolute;
            top: 39%;
            right: 19.2%;
          }
        }
      }
    }
  }
}
@media (min-width: 376px) and (max-width: 414px) {
  .course-section {
    .allContent_wrap {
      .allContent {
        .allContent_right {
          .img2 {
            left: 124px;
          }
          .img3 {
            left: 231px;
          }
        }
      }
    }
    .practice_wrap {
      .learning {
        .five {
          background-size: 40% 57%;
          .center {
            .curr_img8 {
              top: 25%;
            }
          }
        }
      }
      .chinese {
        margin-top: 567px;
      }
    }
    .person_wrap {
      .person {
        .allFonts {
          .Empathy {
            top: 26px;
            left: 44.5%;
          }
          .Collaboration {
            top: 45px;
            left: 63%;
          }
          .Confidence {
            top: 93px;
            left: 78%;
          }
          .Perseverance {
            top: 164px;
            left: 83%;
          }
          .Gratitude {
            top: 232px;
            left: 79.5%;
          }
          .Citizenship {
            top: 284px;
            left: 64%;
          }
          .Integrity {
            top: 300px;
            left: 45%;
          }
          .Leadership {
            top: 284px;
            left: 24%;
          }
          .Insightfulness {
            top: 232px;
            left: 7.5%;
          }
          .Ingenuity {
            top: 164px;
            left: 4%;
          }
          .Self-Mastery {
            top: 93px;
            left: 7.5%;
          }
          .Proactiveness {
            top: 45px;
            left: 22%;
          }
        }
      }
    }
    .child_wrap  {
      .child {
        .three {
          height: 103px!important;
        }
      }
    }
  }
}
@media (min-width: 321px) and (max-width: 360px) {
  .course-section {
    .allContent_wrap {
      .allContent {
        .allContent_right {
          .img2, .img3 {
            p, h5 {
              font-size: 10px;
            }
          }
          .img1 {
            left: 10px;
          }
          .img2 {
            left: 105px;
          }
          .img3 {
            left: 200px;
          }
        }
      }
    }
    .child_wrap  {
      .child {
        .three {
          height: 93px!important;
        }
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 320px) {
  .course-section {
    .allContent_wrap {
      .allContent {
        .allContent_right {
          .img1, .img2, .img3 {
            p, h5 {
              font-size: 10px;
            }
          }
          .img1 {
            left: 10px;
          }
          .img2 {
            left: 95px;
          }
          .img3 {
            left: 178px;
          }
        }
      }
    }
    .practice_wrap {
      .learning {
        .five {
          height: 184px;
          background-size: 40% 54%;
          .center {
            .curr_img8 {
              top: 21%;
            }
          }
        }
        #second {
          height: 296px;
        }
      }
      .trend p {
        height: 230px;
      }
      .chinese {
        margin-top: 485px;
        p {
          height: 188px;
        }
        .cae {
          #second {
            height: 104px;
          }
        }
      }
    }
    .child_wrap  {
      .child {
        .three {
          height: 86px!important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/choose/course.vue